import React, { ReactNode, useEffect } from 'react';
import { SliderManagerStore } from './slider-manager.store';
import { useNavigate } from 'react-router-dom';

const CreateResumeContext = React.createContext<SliderManagerStore | null>(null);

export const SliderManagerProvider = ({ children }: { children: ReactNode }) => {
   const navigate = useNavigate();
   const [store] = React.useState<SliderManagerStore>(() => new SliderManagerStore(navigate));

   return <CreateResumeContext.Provider value={store}>{children}</CreateResumeContext.Provider>;
};

export const useSliderManager = () => {
   const ctx = React.useContext(CreateResumeContext);
   if (!ctx) {
      throw new Error('useSliderManager must be used inside SliderManagerProvider');
   }
   return ctx;
};
